<template>
  <div v-loading="isLoading">
    <button
      @click="handleExec()"
      class="btn btn-danger btn-fill btn-wd"
      title="Avalia os documentos verificando se há algum duplicado e remove-os do sistema"
    >
      Remover tickets duplicados
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'

export default {
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    }
  },

  computed: {
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt(this.progress * 100 / this.total)
    }
  },

  methods: {
    handleExec () {
      this.isLoading = true
      this.progress = 0
      this.exec(response => {
        console.log('end', response)
      })
      .catch(err => console.log(err))
      .finally(response => {
        this.isLoading = false
        this.progress = 100
      })
    },

    async exec (item) {
      let tickets = await Couchdb.collection('tickets')
      .select(['_id', 'customerId', 'eventId', 'documentedAt', 'stockId', 'winner', 'createdAt'])
      .all()
      tickets = this.getDuplicated(tickets)
      if (tickets.length === 0) {
        this.notifyFinish()
      } else {
        tickets = this.getTicketsBeDeleted(tickets)
        this.total = tickets.length
        this.progress = 100
        this.notifyTotal()
        .then(() => {
          this.deleteTickets(tickets)
        })
      }
    },

    getDuplicated (tickets) {
      let duplicated = []
      let counter = {}
      for (let i = 0; i < tickets.length; i++) {
        if (!counter.hasOwnProperty(tickets[i].eventId)) {
          counter[tickets[i].eventId] = {}
        }
        if (!counter[tickets[i].eventId].hasOwnProperty(tickets[i].customerId)) {
          counter[tickets[i].eventId][tickets[i].customerId] = {
            tickets: [tickets[i]]
          }
        } else {
          counter[tickets[i].eventId][tickets[i].customerId]['tickets'].push(tickets[i])
        }
      }
      for (let eventId in counter) {
        for (let customerId in counter[eventId]) {
          if (counter[eventId][customerId]['tickets'].length > 1) {
            duplicated.push(counter[eventId][customerId]['tickets'])
          }
        }
      }
      return duplicated
    },

    getTicketsBeDeleted (tickets) {
      let deleted = []
      for (let i = 0; i < tickets.length; i++) {
        let notWinners = tickets[i].filter(item => {
          return !item.winner
        })
        if (notWinners.length === tickets[i].length) {
          let notDocumentedAt = notWinners.filter(item => {
            return !item.documentedAt
          })
          if (notDocumentedAt.length === tickets[i].length) {
            let minor = notDocumentedAt[0]
            let idMin = 0
            for (let i = 1; i < notDocumentedAt.length; i++) {
              if (minor.createdAt >= notDocumentedAt[i].createdAt) {
                minor = notDocumentedAt[i]
                idMin = i
              }
            }

            let byCreatedAt = notDocumentedAt.filter((item, index) => {
              return index !== idMin
            })
            deleted = this.concatArray(deleted, byCreatedAt)
          } else {
            deleted = this.concatArray(deleted, notDocumentedAt)
          }
        } else {
          deleted = this.concatArray(deleted, notWinners)
        }
      }
      return deleted
    },

    async deleteTickets (tickets) {
      let deletedPromises = []
      for (let i = 0; i < tickets.length; i++) {
        this.progress = i + 1
        deletedPromises.push(
          Couchdb.collection('tickets')
          .delete(tickets[i]._id)
        )
        if (((i + 1) % 5) === 0) {
          await Promise.all(deletedPromises)
          deletedPromises = []
        }
      }
    },

    concatArray (to, from) {
      for (let i = 0; i < from.length; i++) {
        to.push(from[i])
      }
      return to
    },

    notifyFinish () {
      swal({
        title: 'Sucesso',
        text: `Todos os tickets duplicados foram removidos.`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    notifyTotal () {
      return swal({
        title: 'Informativo',
        text: `Existem ${this.total} tickets a duplicados. Eles serão removidos`,
        type: 'info',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/RemoveDuplicatedFiles.vue